/* eslint-disable */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { DrawerContent } from '@progress/kendo-react-layout';
import NavBar from '../components/navBar';
import SideBar from '../components/sideBar';
import { useLocation } from 'react-router-dom';

import './styles.css';

const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(true);
  const location = useLocation();
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const onRefresh = (ev) => {
      const path = ev?.detail?.path;
      if (!path) return;
      if (path === location.pathname) {
        setRefreshKey((k) => k + 1);
      }
    };
    window.addEventListener('route-refresh', onRefresh);
    return () => window.removeEventListener('route-refresh', onRefresh);
  }, [location.pathname]);

  const toggleMenuOpen = () => setMenuOpen(!menuOpen);

  return (
    <div className="LayoutWrapper">
      <SideBar isOpen={menuOpen} />
      <div className="ScreenContent">
        <NavBar clickHamburguerMenu={toggleMenuOpen} menuOpen={menuOpen} />
        <DrawerContent key={refreshKey} className="drawer-content">{children}</DrawerContent>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
